export default "__VITE_ASSET__3da186ea__"